import React from 'react';
import { GlobeIcon, CheckIcon } from 'lucide-react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const stack = [{
  label: '6 Master Volumes',
  value: '$297'
}, {
  label: '5 Exclusive Bonuses',
  value: '$245'
}];
const included = ['One-time payment', 'No subscriptions', 'Instant access', 'Lifetime access'];
export function Offer() {
  return <Section id="offer" dark data-id="element-227" data-mp="3f4a2gc3lkfno">
      <Eyebrow data-id="element-228" data-mp="3f3i814lqknyz">Special launch offer</Eyebrow>
      <Heading data-id="element-229" data-mp="3f27331gk1a6a">Everything you’ll get today</Heading>

      <div className="mt-8 rounded-2xl border border-ink-500 bg-ink-700 p-5" data-id="element-230" data-mp="3jwbcrsh7fwb2">
        <ul className="divide-y divide-ink-500" data-id="element-231" data-mp="3nxdecfylgkg7">
          {stack.map(s => <li key={s.label} className="flex items-center justify-between gap-4 py-3" data-id="element-232" data-mp="3sw6pw2ubm1dq">
              <span className="text-[15px] font-semibold text-zinc-200" data-id="element-233" data-mp="1pn5bvyomx28">{s.label}</span>
              <span className="font-display text-xl font-extrabold text-zinc-400 line-through" data-id="element-234" data-mp="1naqhro812te">
                {s.value}
              </span>
            </li>)}
        </ul>

        <div className="mt-4 flex items-center justify-between gap-4 rounded-xl bg-ink-800 px-4 py-3" data-id="element-235" data-mp="1fl2d91tb52lu">
          <span className="font-display text-lg font-extrabold uppercase tracking-wide text-white" data-id="element-236" data-mp="1bmw8u0fxyz43">
            Total value
          </span>
          <span className="font-display text-2xl font-extrabold text-white line-through decoration-ember decoration-2" data-id="element-237" data-mp="23chjh5o7g42d">
            $542 USD
          </span>
        </div>

        <p className="mt-6 text-center font-display text-lg font-bold uppercase text-zinc-300" data-id="element-238" data-mp="1zcqloi09gnoc">
          But you won’t pay $542…
        </p>
        <p className="mt-1 text-center text-[13px] font-semibold uppercase tracking-wide text-zinc-500" data-id="element-239" data-mp="1plcnqenyjvxb">
          Get the complete Weld Decision System™ today for only
        </p>

        <div className="mt-4 flex items-end justify-center gap-3" data-id="element-240" data-mp="2i8p241jysxfj">
          <span className="font-display text-3xl font-bold text-zinc-500 line-through" data-id="element-241" data-mp="2i7dyc1qirpof">$542</span>
          <span className="font-display text-[76px] font-extrabold leading-[0.8] text-flame-500 sm:text-[96px]" data-id="element-242" data-mp="317k33e4nojad">
            $27
          </span>
          <span className="font-display text-2xl font-extrabold text-white" data-id="element-243" data-mp="2sdyqa0c1xc3l">USD</span>
        </div>

        <ul className="mt-6 grid grid-cols-2 gap-2" data-id="element-244" data-mp="2wdz3xirbtj9l">
          {included.map(i => <li key={i} className="flex items-center gap-2 rounded-lg border border-ink-500 bg-ink-800 px-3 py-2.5" data-id="element-245" data-mp="2ieg8nqjm62ep">
              <CheckIcon className="h-4 w-4 shrink-0 text-flame-400" aria-hidden="true" data-id="element-246" data-mp="2nbzmipcegd64" />
              <span className="text-[12px] font-semibold leading-tight text-zinc-200 sm:text-sm" data-id="element-247" data-mp="29g4cl8zzacev">
                {i}
              </span>
            </li>)}
        </ul>

        <div className="mt-5 flex gap-3 rounded-xl border border-ink-500 bg-ink-800 p-4" data-id="element-248" data-mp="7o99vivp9i8s">
          <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-spark" aria-hidden="true" data-id="element-249" data-mp="bn8f74lcfh0r" />
          <p className="text-[13px] leading-snug text-zinc-300" data-id="element-250" data-mp="1w7lwy5m248is">
            <span className="font-bold text-white" data-id="element-251" data-mp="1s4yxpjn23lbk">Automatic currency conversion.</span> Your
            currency conversion is handled automatically, so you pay the equivalent amount in your
            local currency wherever you are in the world.
          </p>
        </div>

        <div className="mt-5" data-id="element-252" data-mp="213kg9esj30cc">
          <ScarcityBar data-id="element-253" data-mp="2fubasuli8dj5" />
        </div>
      </div>

      <p className="mt-8 text-center font-display text-xl font-extrabold uppercase leading-tight text-white sm:text-2xl" data-id="element-254" data-mp="2fsqcctw2kag0">
        Less than the cost of a small box of welding consumables…
      </p>
      <p className="mt-2 text-center text-[15px] text-zinc-400" data-id="element-255" data-mp="2oupx9xa7fyo8">
        For a practical decision system you can keep using every time you weld.
      </p>

      <div className="mt-7" data-id="element-256" data-mp="ugoxna6tz7n3">
        <CTAButton label="I WANT THE WELD DECISION SYSTEM™" sub="" data-id="element-257" data-mp="ui01fa0a0fe7" />
      </div>
      <div className="mt-6" data-id="element-258" data-mp="pix308esx7f7">
        <Countdown data-id="element-259" data-mp="pjotx5xgegz5" />
      </div>
      <p className="mt-4 text-center text-[11px] font-semibold uppercase tracking-[0.14em] text-zinc-500" data-id="element-260" data-mp="rwsm0wqqi0fe">
        One-time payment · Instant access · Lifetime access · 7-day guarantee
      </p>
    </Section>;
}